
import { supabase } from '../../integrations/supabase/client';

// Upload files to Supabase storage and return URLs
export const uploadFiles = async (
  files: File[], 
  folderName: string,
  maxFileSize: number = 5 * 1024 * 1024 // 5MB
): Promise<string[]> => {
  const urls: string[] = [];
  const bucketName = 'teaching-reports';
  
  try {
    // Check authentication status first
    const { data: sessionData } = await supabase.auth.getSession();
    
    if (!sessionData.session) {
      console.error('User not authenticated, cannot upload files');
      throw new Error('คุณไม่ได้เข้าสู่ระบบ ไม่สามารถอัปโหลดไฟล์ได้');
    }
    
    // Continue with upload
    for (const file of files) {
      // Check file size
      if (file.size > maxFileSize) {
        console.error(`File ${file.name} is too large (max ${maxFileSize} bytes)`);
        throw new Error(`File ${file.name} exceeds size limit of ${maxFileSize} bytes`);
      }
      
      const fileExt = file.name.split('.').pop();
      const fileName = `${Math.random().toString(36).substring(2)}_${Date.now()}.${fileExt}`;
      const filePath = `${folderName}/${fileName}`;
      
      console.log(`Uploading file ${file.name} to ${filePath}...`);
      
      const { error: uploadError, data: uploadData } = await supabase.storage
        .from(bucketName)
        .upload(filePath, file, {
          upsert: true,
          cacheControl: '3600',
        });
        
      if (uploadError) {
        console.error(`Error uploading file to ${folderName}:`, uploadError);
        throw new Error(`Failed to upload files to ${folderName}: ${uploadError.message}`);
      }
      
      console.log('Upload successful:', uploadData);
      
      const { data: { publicUrl } } = supabase.storage
        .from(bucketName)
        .getPublicUrl(filePath);
        
      urls.push(publicUrl);
      console.log(`File uploaded successfully, URL: ${publicUrl}`);
    }
    
    return urls;
  } catch (error) {
    console.error('Error in uploadFiles:', error);
    throw error;
  }
};
